import React from 'react';
import { Modal, Progress } from 'antd';
import { LoadingOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const PaymentStatusModal = ({ 
  visible, 
  status, 
  attempts, 
  maxAttempts,
  onCancel 
}) => {

  const isPending = status === 'pending';
  const isCompleted = status === 'completed';
  const isFailed = status === 'failed';
  
  
  const progressPercent = Math.min((attempts / maxAttempts) * 100, 100);

  const getIcon = () => {
    if (isCompleted) {
      return <CheckCircleOutlined style={{ fontSize: 64, color: '#52c41a' }} />;
    }
    if (isFailed) {
      return <CloseCircleOutlined style={{ fontSize: 64, color: '#ff4d4f' }} />;
    }
    return <LoadingOutlined style={{ fontSize: 64, color: '#1890ff' }} spin />;
  };

  const getMessage = () => {
    if (isCompleted) {
      return 'Ubwishyu bwawe bwemejwe neza!';
    }
    if (isFailed) {
      return 'Ubwishyu bwawe ntibwagenze neza. Ongera ugerageze.';
    }
    return 'Turimo kwemeza ubwishyu bwawe...';
  };

  const getSubMessage = () => {
    if (isPending) {
      return 'Nyamuneka utegereze. Ibi bishobora gufata iminota imwe cyangwa ebyiri.';
    }
    if (isCompleted) {
      return 'Uzakora icyiciro gikurikira.';
    }
    return '';
  };

  return (
    <Modal
      open={visible}
      onCancel={isFailed ? onCancel : undefined}
      footer={null}
      closable={!isPending}
      centered
      width={400}
    >
      <div className="text-center py-6">
        <div className="mb-4">
          {getIcon()}
        </div>
        
        <h3 className="text-xl font-semibold mb-2 text-gray-800">
          {getMessage()}
        </h3>
        
        {getSubMessage() && (
          <p className="text-gray-600 mb-4">
            {getSubMessage()}
          </p>
        )}
        
        {isPending && (
          <div className="mt-4">
            <Progress 
              percent={progressPercent} 
              status="active"
              showInfo={false}
            />
            <p className="text-sm text-gray-500 mt-2">
              Igerageza {attempts} / {maxAttempts}
            </p>
          </div>
        )}

        {isPending && (
          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              💡 Emeza ubwishyu kuri telefoni yawe
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PaymentStatusModal;